import React, { useEffect, useState } from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  IconButton,
  TableContainer,
  TableHead,
  Typography,
  Radio,
} from "@mui/material";
import moment from "moment";
import Iconify from "../iconify";
import { patch } from "src/utils/networkUtils";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
const ArchivedDrawTable = ({ rows, handleOpenMenu }) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map(
            (row, index) =>
              row !== null &&
              row !== undefined && (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.raffleId}
                  </TableCell>

                  <TableCell>
                    <Typography variant="subtitle2">{row.title_en}</Typography>
                  </TableCell>

                  <TableCell>
                    {moment(row.startDate).format("ddd MMM D, YYYY")}
                  </TableCell>
                  <TableCell>
                    {moment(row.closeDate).format("ddd MMM D, YYYY")}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="large"
                      color="inherit"
                      onClick={(event) => {
                        handleOpenMenu(event, row);
                      }}
                      id={row.raffleId}
                    >
                      <Iconify icon={"eva:more-vertical-fill"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ArchivedDrawTable;
